'use client';

import { useLocalStorage } from '@/hooks/use-local-storage';
import { useOnMount } from '@/hooks/use-on-mount';
import { LocalStorageKeys } from '@/lib/local-storage';
import {
    AbstractIntlMessages,
    IntlError,
    NextIntlClientProvider,
    RichTranslationValues,
} from 'next-intl';
import type { FC, PropsWithChildren } from 'react';

const defaultTranslationValues: RichTranslationValues = {
    i: (text) => <i>{text}</i>,
};

const getMessageFallback = ({
    namespace,
    key,
    error,
}: {
    error: IntlError;
    key: string;
    namespace?: string;
}) => {
    if (error.code === 'MISSING_MESSAGE') {
        console.error(`Missing translation: ${namespace}.${key}`, { error });
        return 'TRANSLATION_MISSING';
    }
    return `${namespace}.${key}`;
};

export const LocaleClientProvider: FC<
    PropsWithChildren<{
        messages: AbstractIntlMessages;
        timeZone: string;
        locale: string;
    }>
> = ({ children, ...rest }) => {
    const [_, setLocaleOnLocal] = useLocalStorage(
        LocalStorageKeys.Locale,
        rest.locale
    );

    useOnMount(() => {
        setLocaleOnLocal(rest.locale);
    });

    return (
        <NextIntlClientProvider
            {...rest}
            // defaultTranslationValues={defaultTranslationValues}
            getMessageFallback={getMessageFallback}
        >
            {children}
        </NextIntlClientProvider>
    );
};
